import resourceService from './resource_service';

const modelName = 'consumption-report';

const attributes = {
  name: '',
  consumption: {},
};

const relationships = {};

export default resourceService(modelName, attributes, relationships);
